/**
 * Created by shinan.chen on 2021/12/25.
 */
import {getCommon, postCommon } from '../tools';
import * as config from '../config';

export interface IFile{
    id:number,
    name:string,
    url:number,
    enable:boolean,
}

export const listFiles = () =>
    getCommon({
        url: `${config.SERVICE_URL}/file/list_all`,
    });

    export const listFilesByStudentId = (studentId:number) =>
    getCommon({
        url: `${config.SERVICE_URL}/file/list_by_student_id?studentId=`+studentId,
    });

export const createFile = (data:IFile) =>
    postCommon({
        url: `${config.SERVICE_URL}/file/create`,
        data
    });

export const updateFile = (data:IFile) =>
    postCommon({
        url: `${config.SERVICE_URL}/file/update`,
        data
    });

export const deleteFile = (id:number) =>
    postCommon({
        url: `${config.SERVICE_URL}/file/delete?id=${id}`
    });

export const enableFile = (id:number, enable:boolean) =>
    postCommon({
        url: `${config.SERVICE_URL}/file/enable?id=${id}&&enable=${enable}`
    });

export const pageFiles = (pageNum:number,pageSize:number,storeIds:any,keyword:string) =>
    getCommon({
        url: `${config.SERVICE_URL}/file/page?pageNum=${pageNum}&&storeIds=${storeIds}&&pageSize=${pageSize}&&keyword=`+encodeURI(keyword),
    });